// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4313":"8e30a434731d97af","9296":"61c667517e037d98"}[chunkId] + ".css";
};